<template>
	<div class="absolute left-[22%] top-4 p-4 rounded-sm bg-white-neutral">
		<h1 class="text-H5">Nova Ordem de Serviço</h1>

		<div>
			<label class="text-label">tipo de ordem de serviço</label>
			<p class="text-s">
				{{ tipoOrdemServico.descricao }}
			</p>
		</div>
		<div>
			<label class="text-label">descrição</label>
			<p class="text-s">
				{{ ordemServico.orsv_ds_descricao }}
			</p>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import { tipoDeOrdemDeServicoComDescricao } from '../../../constants/Mappings/TiposDeOrdensDeServico.js'
const props = defineProps({
	ordemServico: Object,
})

const tipoOrdemServico = computed(() => {
	return tipoDeOrdemDeServicoComDescricao.find(
		(tipo) => tipo.codigo === props.ordemServico.orsv_cd_tipo_servico,
	)
})
</script>

<style></style>
